import React from 'react';
import { ReactComponent as InfoErrorIcon } from '@assets/icons/info_error_icon.svg';
import { ReactComponent as CheckSuccessIcon } from '@assets/icons/check_activity_success_icon.svg';
import { ReactComponent as WarningIcon } from '@assets/icons/warning_icon.svg';
import clsx from 'clsx';

type Props = {
  label: any;
  value: string;
  success?: boolean;
  /** Shown when success is false; defaults to error (red) for safety */
  alertVariant?: 'error' | 'warning';
  onClick: (value: string) => void;
  active: boolean;
  hideIcon?: boolean;
  className?: string;
  progressLabel?: string;
};

const StatusListItem: React.FC<Props> = ({
  label,
  value,
  success,
  alertVariant = 'error',
  onClick,
  active,
  hideIcon,
  className,
  progressLabel
}) => {
  const renderStatusIcon = () => {
    if (success) {
      return <CheckSuccessIcon className="w-4 h-4" />;
    }
    if (alertVariant === 'warning') {
      return <WarningIcon className="w-4 h-4" />;
    }
    return <InfoErrorIcon className="w-4 h-4" />;
  };

  return (
    <div
      className={clsx(
        'px-3 py-2 flex items-center gap-2 border border-transparent rounded-lg mb-1 cursor-pointer hover:bg-grey-50',
        active && 'bg-grey-50 !border-error-light',
        className
      )}
      onClick={() => onClick(value)}>
      <div className="flex gap-2">
        <span
          className={clsx(
            'font-semibold text-grey-500 text-sm whitespace-pre-line',
            active && 'text-secondary'
          )}>
          {label}
        </span>
        {progressLabel && (
          <span className="text-secondary text-xs border border-grey-300 rounded-md bg-white px-[6px] py-[2px] self-start flex-shrink-0">
            {progressLabel}
          </span>
        )}
      </div>
      <div className="">{!hideIcon && renderStatusIcon()}</div>
    </div>
  );
};

export default StatusListItem;
